import {errorHttpMessage} from "@/utils/errorDecodeUtil"
import configurationClient from '@/axiosClients/configurationClient'
import {makeRestoreAction} from '@/utils/catalogRestoreAction'

export const saveIncapacityReason = async ({commit}, incapacityReason) => {
    try {
        const {data: result} = await configurationClient.post('/catalog/incapacityReason/create', incapacityReason)
        const {message, error} = result.result
        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const findIncapacityReasonById = async ({commit}, id) => {
    try {
        const {data: result} = await configurationClient.get(`/catalog/incapacityReason/show/${id}`)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const editIncapacityReason = async ({commit}, incapacityReason) => {
    try {
        const {data: result} = await configurationClient.post(`/catalog/incapacityReason/${incapacityReason.id}`, incapacityReason)
        const {message, error} = result.result
        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const deleteIncapacityReason = async ({commit}, id) => {
    try {
        const {data: result} = await configurationClient.delete(`/catalog/incapacityReason/destroy/${id}`)
        const {message, error} = result.result
        return {message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const downloadExcelReport = async ({commit}, fileName) => {
    try {
        const response = await configurationClient.get(`/catalog/incapacityReason/download`, {responseType: 'blob'})
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.xlsx`);
        document.body.appendChild(link);
        link.click();
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }
}

export const restoreById = makeRestoreAction(configurationClient, '/catalog/incapacityReason')
